import React from 'react'

import { IconProps } from '../Types'

export const PinOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="PinOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m15.38,8.9c0,1.81-1.51,3.27-3.38,3.27s-3.38-1.46-3.38-3.27,1.51-3.27,3.38-3.27,3.38,1.46,3.38,3.27Zm-2.07,0c0,.7-.58,1.26-1.3,1.26s-1.3-.57-1.3-1.26.58-1.26,1.3-1.26,1.3.57,1.3,1.26Z"/><path fill-rule="evenodd" d="m12,2c-4.42,0-8,3.47-8,7.75,0,1.14.41,2.45.97,3.72.57,1.29,1.34,2.63,2.15,3.84.81,1.21,1.67,2.31,2.43,3.12.38.4.76.76,1.11,1.02.18.13.37.26.57.35.19.09.46.19.77.19s.58-.1.77-.19c.2-.09.39-.22.57-.35.35-.26.73-.62,1.11-1.02.77-.81,1.63-1.92,2.43-3.12.81-1.21,1.58-2.55,2.15-3.84.56-1.27.97-2.59.97-3.72,0-4.28-3.58-7.75-8-7.75Zm-5.93,7.75c0-3.17,2.65-5.74,5.93-5.74s5.93,2.57,5.93,5.74c0,.73-.28,1.75-.81,2.93-.52,1.17-1.22,2.4-1.98,3.54-.76,1.14-1.55,2.15-2.22,2.86-.34.36-.62.62-.84.78-.03.02-.05.04-.07.05-.02-.02-.05-.03-.07-.05-.22-.16-.51-.42-.84-.78-.67-.71-1.46-1.72-2.22-2.86-.76-1.14-1.47-2.38-1.98-3.54-.53-1.19-.81-2.21-.81-2.93Z"/>',
    }}
  />
)

PinOutline.displayName = 'PinOutline'

export const tags = ['PinOutline', '']
